import { render, staticRenderFns } from "./TreatDiagList.vue?vue&type=template&id=6a033830"
import script from "./TreatDiagList.vue?vue&type=script&lang=js"
export * from "./TreatDiagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports